import React from "react"
import Lang from "@components/Lang/Lang"
import {Modal, Form, Input, DatePicker, Select, } from "antd"
import dayjs from 'dayjs'
import './ExportData.less'
import {getSomeTimeMilliseconds} from '@/utils/timeHandler'

const { RangePicker } = DatePicker;
const { Option } = Select;
const config = require("../../../../../config/config");
const Locale = require("../../../../utils/locale").default;
let locale = Locale.current();
const ExportData = (props) => {
    // console.log('props.isModalVisible', props.isModalVisible);

    const [form] = Form.useForm()

    const handleOk = () => {
        const formData = form.getFieldsValue() || {}

        // console.log(dayjs(formData.time1[0]._d).valueOf());
        let template =
            locale === "ru" ? "MgFenxiaoCommissionReport_ru" : "MgFenxiaoCommissionReport_zh";
        let href = config.servers[config.environment].exportApi +
            `/data/bpms/jreport/mg/fexiaoCommission/print?template=${template}&%24isGetHttpConfig=true&isCheck=0`;
        //地址拼接，如果没有数据也要拼接
        href += `&createTimeStart=${(formData.time1&&getSomeTimeMilliseconds(formData.time1[0], '00:00:00')) || ""}`;
        href += `&createTimeEnd=${(formData.time1&&getSomeTimeMilliseconds(formData.time1[1], '23:59:59')) || ""}`;
       href += `&fucName=${(formData.fucName&&formData.fucName.trim()) || ""}`
        href += `&happenTimeStart=${(formData.time2&&getSomeTimeMilliseconds(formData.time2[0], '00:00:00')) || ""}`;
        href += `&happenTimeEnd=${(formData.time2&&getSomeTimeMilliseconds(formData.time2[1], '23:59:59')) || ""}`;

        window.open(href);

        handleCancel()
    };

    const handleCancel = () => {
        props.showSwich(false)
    };

    return (
        <Modal title={Lang({id: 'DaoChuShuJuShaiXuan', default: '导出数据筛选'})}
               className="distributor-statistics-exportModal"
               width={locale === "ru" ? 610 : 520}
               open={props.isModalVisible}
               onOk={handleOk}
               onCancel={handleCancel}
               cancelText={Lang({id: 'QuXiao', default: '取消'})}
               cancelButtonProps={{shape:'round'}}
               okButtonProps={{type:'primary', shape:'round'}}
               okText={Lang({id: 'DaoChu', default: '导出'})}>
            <Form labelCol={{span: locale === "ru" ? 10 : 5}}
                  form={form}
                  labelAlign="left">
                <Form.Item
                    name="time1"
                    label={(
                        <span className="label-txt">{Lang({id: 'JiaRuShiJian', default: '加入时间'})}</span>
                    )}>
                    <RangePicker
                        style={{width: '312px'}}
                        placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                </Form.Item>

                <Form.Item
                    name="time2"
                    label={(
                        <span className="label-txt">{Lang({id: 'ZhiFuWeiKuanShiJian', default: '支付尾款时间'})}</span>
                    )}>
                    <RangePicker
                        style={{width: '312px'}}
                        placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                </Form.Item>

                <Form.Item
                    name="fucName"
                    label={(
                        <span className="label-txt">{Lang({id: 'FenXiaoShang', default: '分销商'})}</span>
                    )}>
                    <Input
                        style={{width: '312px'}}
                        placeholder={Lang({id: 'FenXiaoShangXingMing', default: '请输入分销商名称'})} />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ExportData
